import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    errors: {
        /** Error when template name exceeds length limit */
        templateNameTooLong: string;
        /** Error when template name already exists */
        templateNameExists: string;
        /** Error when required field is missing */
        required: (field: string) => string | React.ReactNode;
    };
    watermarkTemplates: string;
    cancel: string;
    apply: string;
    save: string;
    create: string;
    back: string;
    close: string;
    createNewTemplate: string;
    editTemplate: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Error messages for form validation */
            errors: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Error when template name exceeds length limit */
                        templateNameTooLong: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateManagerDialog.errors.templateNameTooLong?c=2ocpubow5rbxs", defaultMessage: "Template name is too long" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Error when template name already exists */
                        templateNameExists: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateManagerDialog.errors.templateNameExists?c=1fym39gm2vmt6", defaultMessage: "Template name already exists" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Error when required field is missing */
                        required: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (field: string) => __intl__.intl().formatMessage({ id: "WatermarkTemplateManagerDialog.errors.required?c=q1rdf3pqrr6o", defaultMessage: "{field} is required" }, { field: field }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Title for watermark templates section */
            watermarkTemplates: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateManagerDialog.watermarkTemplates?c=1iphehz4v9ehx", defaultMessage: "Watermark Templates" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Cancel button label */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateManagerDialog.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Apply button label */
            apply: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateManagerDialog.apply?c=2yuyex7po7uv3", defaultMessage: "Apply" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Save button label */
            save: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateManagerDialog.save?c=1oof7q3mpz3f9", defaultMessage: "Save" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Create button label */
            create: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateManagerDialog.create?c=eq4dbgfgoje4", defaultMessage: "Create" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Back button label */
            back: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateManagerDialog.back?c=2sja1esxksx0w", defaultMessage: "Back" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Close button label */
            close: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateManagerDialog.close?c=1h3mba94p9xl7", defaultMessage: "Close" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for creating new template */
            createNewTemplate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateManagerDialog.createNewTemplate?c=n9l4q397ibtw", defaultMessage: "New Watermark Template" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for editing template */
            editTemplate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateManagerDialog.editTemplate?c=22fva9cfdwo9p", defaultMessage: "Edit Watermark Template" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
